import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "message", "status", "popupStatusProps"];
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import PopupStatus from '../popup-status';
import CrossButton from '../cross-button/cross-button.component';
import Styled from './popup-content.styles';
import { Status } from '../popup-status/types';
var PopupContent = intrinsicComponent(function (_ref, ref) {
  var onClose = _ref.onClose,
    message = _ref.message,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? Status.Success : _ref$status,
    popupStatusProps = _ref.popupStatusProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.PopupContent, _extends({}, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Styled.PopupStatus, _extends({
    status: status,
    message: message
  }, popupStatusProps), /*#__PURE__*/React.createElement(PopupStatus, {
    status: status
  })), /*#__PURE__*/React.createElement(Styled.LabelWrapper, null, /*#__PURE__*/React.createElement(Styled.Label, null, message)), /*#__PURE__*/React.createElement(Styled.CloseWrapper, null, /*#__PURE__*/React.createElement(CrossButton, {
    size: "sm",
    onClick: onClose
  })));
});
export default PopupContent;